<template>
    <div class="profile-password">

        <data-form title="Reset Password"
                   tag="profile-password"
                   save-button-label="Submit"
                   :field-model="userFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/profile/view"
                   submit-success-message="Password changed"
                   submit-error-message="Error changing password"
                   submit-success-route="/profile/view">
            <template v-slot:twofa_enabled="slotProps">
                <div v-if="slotProps.form.twofa_enabled && userInfo['twofa_uri']">
                    <img :src="userInfo['twofa_uri']" alt="QR Code for Google Authenticator"/>
                </div>
            </template>
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import UserFields from '@/models/User'

export default Vue.extend({
    name: 'ProfilePassword',
    data () {
        return {
            userFields: UserFields,
            userInfo: {}
        }
    },
    computed: {
        fieldGroups () {
            return [
                ['current_password', 'password', 'password_repeat', 'twofa_enabled']
            ]
        },
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'user', this.$user.userId())
        },
        async onSubmit (modelInstance) {
            try {
                return await this.$api.updateItem(this, 'user', modelInstance)
            } catch (e) {
                this.$toasted.error(e.body.message) // show specific error message (e.g. wrong current password)
                throw e // pass on to generic DataForm error handling
            }
        }
    },
    created () {
        this.$api.getItem(this, 'user', this.$user.userId())
            .then((data) => {
                this.userInfo = data
            })
    },
})

</script>

